let inject = [
    '$scope',
    'SharedService',
    'LandingService',
    '$state',
    '$rootScope',
    '$window',
    '$timeout'
  ];
  
  class LandingController {
    constructor($scope, SharedService,LandingService, $state, $rootScope, $timeout, $window) {
      this.$state = $state;
      this.$scope = $scope;
      this.$window = $window;
      this.$timeout = $timeout;
      this.$rootScope = $rootScope;
      this.SharedService = SharedService;
      this.LandingService = LandingService;
      this.pageName = "B2B-PAG-48";
        
      this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0).then(response => {
          this.cmsData = response;
      });
      
    }
  
    $onInit() {
    }
  
  
  
  }
  
  LandingController.$inject = inject;
  
  export default LandingController;
  
  


/** WEBPACK FOOTER **
 ** ./www/components/landing/landing.controller.js
 **/